// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2ffhc","col":"styles_col__1eX5e"};